const EMPTY_FILL_COLOR = 'rgb(242, 242, 242)'; // #F2F2F2
const FILLED_FILL_COLOR = 'rgb(67, 56, 68)'; // #433844
const SELECTED_STROKE_COLOR = 'rgb(237, 28, 36)'; // #ED1C24
const UNSELECTED_STROKE_COLOR = 'rgb(204, 204, 204)'; // #CCCCCC
const FILLED_STROKE_COLOR = 'rgb(67, 56, 68)'; // #433844

class BlockBuilderSlotSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slotSelectorSVG = this.querySelector('#bb-slot-selector-svg svg');
    this.allSlotNodes = this.slotSelectorSVG.querySelectorAll('[id^="bb-slot-"]');
    this.allSlotNodes.forEach((node) => {
      node.style.fill = EMPTY_FILL_COLOR;
      node.style.stroke = UNSELECTED_STROKE_COLOR;
    });
  }

  setCurrentSlots(slotHandle) {
    this.currentSlotNodes = this.slotSelectorSVG.querySelectorAll(`[id^="${slotHandle}_"]`);
    this.allSlotNodes.forEach((node) => {
      node.style.stroke = node.id.includes(`${slotHandle}_`) ? SELECTED_STROKE_COLOR : UNSELECTED_STROKE_COLOR;
    });
  }

  clearCurrentSlots() {
    this.currentSlotNodes.forEach((node) => {
      node.style.stroke = UNSELECTED_STROKE_COLOR;
    });
  }

  updateFilledSlots(quantity) {
    this.currentSlotNodes.forEach((node, index) => {
      node.style.fill = index < quantity ? FILLED_FILL_COLOR : EMPTY_FILL_COLOR;
    });
  }

  clearAllSlots() {
    this.allSlotNodes.forEach((node) => {
      node.style.fill = EMPTY_FILL_COLOR;
    });
  }

  setInitialFilledSlots(cartItems) {
    const slotCollections = cartItems.map((item) => item.slotCollection);
    const uniqueSlotCollections = [...new Set(slotCollections)];

    uniqueSlotCollections.forEach((slotCollection) => {
      if (!slotCollection) return;
      const slotItems = cartItems.filter((item) => item.slotCollection === slotCollection);
      const quantity = slotItems.reduce((acc, item) => acc + item.quantity, 0);
      const slotNodes = Array.from(this.allSlotNodes).filter((node) => node.id.includes(`${slotCollection}_`));
      
      for (let i = 0; i < quantity; i++) {
        slotNodes[i].style.fill = FILLED_FILL_COLOR;
      }
    });
  }

  getFirstEmptySlotHandle() {
    return Array.from(this.allSlotNodes).find(node => node.style.fill === EMPTY_FILL_COLOR)?.id.split('_')[0];
  }
}

customElements.define('block-builder-slot-selector', BlockBuilderSlotSelector);